var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-point-maps",style:({ width: (_vm.gMapsWidth + "px"), height: (_vm.gMapsHeight + "px") })})}
var staticRenderFns = []

export { render, staticRenderFns }